module.exports = __webpack_public_path__ + "img/product10-jiaoyi.481eebe4.svg";